import React, { useState } from "react";
import { Button, FormControl, TextField, Box, Typography, Paper, CircularProgress, Backdrop, Stack } from '@mui/material';
import { useNavigate } from "react-router-dom";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';

const LoadingScreen = ({ open }) => (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
    </Backdrop>
);

function CreateType(props) {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState({
    Id: "",
    Type: "",
    Name: "",
    Image: "",
    UpdatedBy: "",
    CreatedBy: "",
  });
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

//   const initRetrieve = () => {
//     Promise.all([
//         apiConfig.fetchRobotData(0),
//         apiConfig.fetchRobotSite(id)
//     ]).then(results => {
//         console.log(results[0])
//         setRobots(results[0].RobotResponse)
//         console.log(results[1])
//         setSite(results[1].RobotResponse)
//     }).catch(error => {
//         console.error(error);
//     });
//   }

//   useEffect(() => {
//     initRetrieve()
//   }, []);

  const handleCreate = () => {
    console.log(type)
    setLoading(true);
    Promise.all([
        apiConfig.createRobotType(type),
    ]).then(results => {
        // setTimeout(() => {
        console.log(results[0])
        setLoading(false);
        navigate("/managements/type_management");
        // }, 5000);
    }).catch(error => {
        console.error(error);
        alert(error)
        setLoading(false)
    });
  }

  const handleTypeChanges = (e) => {
    const { name, value } = e.target;
    setType(prevState => ({ ...prevState, [name]: value }));
    setType(prevState => ({ ...prevState, "UpdatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
    setType(prevState => ({ ...prevState, "CreatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
  };

  const handleCancel = () => {
    setLoading(false)
    setType({})
    navigate("/managements/type_management");
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setType((prev) => ({
        ...prev,
        Image: reader.result.split(',')[1] // remove MIME type
      }));
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box p={2}>
    <LoadingScreen open={loading} />
      <Typography variant="h4">Create New Robot Type</Typography>
      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        <form onSubmit={(e) => { e.preventDefault(); handleCreate(); }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
                fullWidth
                label="Robot Type"
                name="Type"
                variant="outlined"
                value={type.Type}
                InputLabelProps={{ shrink: true }}
                onChange={handleTypeChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Name"
                name="Name"
                variant="outlined"
                value={type.Name}
                InputLabelProps={{ shrink: true }}
                onChange={handleTypeChanges}
                sx={{ mb: 2 }}
            />
          </FormControl>

          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Button variant="contained" component="label">
              Upload Image
              <input hidden type="file" accept="image/*" onChange={handleImageUpload} />
            </Button>

            {type.Image && (
              <img
                src={`data:image/jpeg;base64,${type.Image}`}
                alt="robot"
                style={{
                  maxHeight: '120px',
                  minHeight: '80px',
                  maxWidth: '100%',
                  height: 'auto',
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
            )}
          </Stack>

          <Button variant="contained" color="primary" type="submit">
            Create
          </Button>
          <Button variant="contained" color="primary" type="button" onClick={handleCancel}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default CreateType;
